<template>
    <div class="p-3">
        <form-modal
            :id="rubrica"
            placeholder-button="Inserir" 

            :title-modal="titulo"

            :fields="colunasAcoes"
            :values="dados"

            ref="modalForm"

            :create="permissao.c && projetoEditavel"
            :read="permissao.r"
            :update="permissao.u"
            :remove="permissao.d && projetoEditavel"

            :somente-ok="!projetoEditavel"
            :ok-cancel="!projetoEditavel"

            :controles="controlesLiberados"

            @ok="ok"
            @edit="editar"
            @remove="deletar"
        >
            <template #modal>                
                <component :is="componente" :projeto-id="projetoId" :projeto-editavel="projetoEditavel" ref="modal" @salvar="salvar" @downloadArquivo="downloadArquivo"/>
            </template>
        </form-modal>
    </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import ProjetoService from "@/common/services/projeto/projeto.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";

import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";

export default {
    mixins: [AlertasMixin],
    components: {
        FormModal,
        
        'producao-cientifica': () => import('../producao_cientifica/modal.vue'),
        'capacitacao-profissional': () => import('../capacitacao_profissional/modal.vue'),
        'impacto-economico': () => import('../impactos_economicos/modal.vue'),
        'impacto-socioambiental': () => import('../impactos_socioambientais/modal.vue'),
        'apoio-infraestrutura': () => import('../apoio_infraestrutura/modal.vue'),
        'propriedade-intelectual': () => import('../propriedade_intelectual/modal.vue'),
        
    },
    props: {
        projetoId: {
            type: String,
            required: true
        },
        titulo: {
            type: String,
            default: 'GENERICO'
        },
        colunas : {
            type: Array,
            default: () => ([])
        },
        rubrica : {
            type: String,
            default: ''
        },
        componente : {
            type: String,
            default: ''
        },
        endpoint : {
            type: String,
            default: ''
        },
        chavePermissao : {
            type: String,
            default: ''
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
        
    },
    data: () => ({
        dados : [],
    }),
    mounted(){
        this.buscar();
    },
    methods : {
        ok : function(){
            this.$refs.modal.salvar();
        },
        salvar : function(e){
            let form = cloneDeep(e);
            if(!this.$refs.modal.validateState())
                return;

            this.confirmar('Aviso','Deseja salvar?').then(confirmado => {
                if(confirmado){

                    // Inseri o id do projeto
                    form.projetoId = this.projetoId;

                    if(form.nomeArquivoAWSUP != null){
                        form.nomeArquivoAWS = form.nomeArquivoAWSUP;
                        delete form['nomeArquivoAWSUP'];
                    }

                    this.$store.dispatch(START_LOADING);
                    ProjetoService.setEndpoint('Projeto');
                    ProjetoService.salvarGenerico(this.rubrica,form).then(() => {
                        this.alertaSucesso('Salvo com sucesso!').then(() => {
                            this.$refs.modalForm.closeModal();
                            this.buscar();
                        });
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao salvar");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                    ProjetoService.setEndpoint(this.endpoint);
                }
            })
        },

        deletar : function(item){
            this.confirmar('Aviso','Deseja realmente excluir?').then(confirmado => {
                if(confirmado){

                    this.$store.dispatch(START_LOADING);
                    ProjetoService.setEndpoint('Projeto');
                    ProjetoService.deletarGenerico(this.rubrica,item.id).then(() => {
                        this.alertaSucesso('Excluido com sucesso!');
                        this.buscar();
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao excluir");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                    ProjetoService.setEndpoint(this.endpoint);
                }
            })
        },

        editar : function(item){
            let form = cloneDeep(item);
            this.$refs.modalForm.openModal().then(() => {
                this.$refs.modal.editar(form);
            });
        },

        buscar : function(){
            this.$store.dispatch(START_LOADING);
            ProjetoService.setEndpoint('Projeto');
            ProjetoService.listarGenerico(this.rubrica,this.projetoId).then(response => {
                this.dados = response.data.data.itens;
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
            ProjetoService.setEndpoint(this.endpoint);
        },

        downloadArquivo : function(arquivoId){
            this.$store.dispatch(START_LOADING);
            
            ProjetoService.setEndpoint('Projeto');
            ProjetoService.downloadArquivoGenerico(this.rubrica, arquivoId)
            .then(response => {
                helpers.baixarArquivo(response.data, response.headers);
                this.alertaSucesso("Download do Arquivo Concluido!");               
            }).catch(err => {
                console.log(err);
                this.alertaErro("Erro ao fazer Download do Arquivo");
            }).finally(() => {
                ProjetoService.setEndpoint(this.endpoint);
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    computed : {
        colunasAcoes : function(){
            let colunas = cloneDeep(this.colunas);
            colunas.push({ key: "actions", label: "Ações", });
            return colunas
        },
        controlesLiberados :function(){
            return (this.$route.name == 'projeto-detalhamento-executora-criadora' || this.$route.name == 'projeto-detalhamento-executora-associada')
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao'](this.chavePermissao);
        },
    }
    
}
</script>
<style lang="">
    
</style>